import React, { Component } from "react";
import PropTypes from "prop-types";
import { toJS } from "mobx";
import { observer, inject } from "mobx-react";
import { withRouter } from "react-router";
import { GridRow, GridColumn, Select, Utils } from "arv-reactcomponents";
import BodyOverlay from "../../BodyOverlay";
import { getFilterUrl, getCurrentHref } from "../../../utils";
import SelectedFilters from "../../../component/SelectedFilters";
import Analytics from "../../../analytics";
import Event from "../../../analytics/eventFactory";

@withRouter
@inject("ProductStore")
@observer
class ProductListTopbarDesktop extends Component {
  static getList(item) {
    return (
      <li className="nw-common-selectlist" key={item.value}>
        {item.displayName}
      </li>
    );
  }

  constructor(props) {
    super(props);
    this.state = {};
    this.getSortSelection = this.getSortSelection.bind(this);
    this.selectedListobj = this.selectedList();
  }

  componentWillReceiveProps() {
    this.selectedListobj = this.selectedList();
  }

  getSortSelection(sortBySelected) {
    if (sortBySelected.isSelected) {
      return null;
    }
    BodyOverlay.component.show();
    const { pathname, search } = this.props.location;
    const pagePath = `${pathname}${search}`;
    const { ProductStore } = this.props;

    ProductStore.setListingPageNo(1);
    const pathWithPageNo = Utils.setUrlParameter(pagePath, "p", 1);

    const filterUrl = getFilterUrl(
      sortBySelected,
      ProductStore.ProductData.sorts.mapping,
      pathWithPageNo,
    );
    const newUrl = `${pathname}?${filterUrl}`;

    ProductStore.getAllProductData(newUrl).then(() => {
      BodyOverlay.component.hide();
    });
    this.props.history.push(newUrl);
    Analytics.trackEvent({
      action: Event.action.getSortType(sortBySelected.value),
      label: getCurrentHref(),
      category: Event.category.LISTING_PAGE,
    });
    return null;
  }

  selectedList() {
    return toJS(this.props.ProductStore.ProductData.sorts.list).find(
      sort => sort.isSelected === true,
    );
  }

  render() {
    if (!this.props.ProductStore.ProductData.sorts.list.length) return null;
    return (
      <GridRow className="nw-productlisttopbar-row">
        <GridColumn className="nwc-grid-col-sm-9">
          <SelectedFilters.component
            selectedFilters={
              this.props.ProductStore.ProductData.selectedFilters
            }
            customPriceFilters={this.props.ProductStore.customPriceFilters}
          />
        </GridColumn>
        <GridColumn className="nwc-grid-col-sm-3 nw-productlisttopbar-container">
          <span className="nw-productlisttopbar-sorttext">SORT:</span>
          <Select
            className="nwc-select-secondary nwc-select-sm nw-productlisttopbar-select nw-common-select"
            selectedValue={this.selectedListobj}
            inpList={toJS(this.props.ProductStore.ProductData.sorts.list)}
            getSelection={this.getSortSelection}
            renderList={ProductListTopbarDesktop.getList}
            compareProp="displayName"
          />
        </GridColumn>
      </GridRow>
    );
  }
}

ProductListTopbarDesktop.wrappedComponent.propTypes = {
  ProductStore: PropTypes.shape({
    customPriceFilters: PropTypes.shape([]).isRequired,
    setListingPageNo: PropTypes.func.isRequired,
    ProductData: PropTypes.shape({
      sorts: PropTypes.shape({
        list: PropTypes.shape(),
      }).isRequired,
      selectedFilters: PropTypes.object,
    }).isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("ProductStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: ProductListTopbarDesktop.wrappedComponent,
  component: ProductListTopbarDesktop,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/ProductListTopbar/Desktop/index.js